angular.module('bbl.directives')
.directive('dialpadWidget', [ '$window', '$document', '$sce', DialpadWidget ]);
require('./dial-btn.directive');

function DialpadWidget($window, $document, $sce) {
  return {
    restrict: 'E',
    templateUrl: 'dialpad-widget-template.html',
    scope: {
      muted: '=',
      status: '=',
      title: '=',
      onLeave: '&',
      onMute: '&',
      onDial: '&',
    },
    controller: ['$scope', function($scope) {
      $scope.tones = {};
      $scope.numericRows = [[1,2,3], [4,5,6], [7,8,9], ['*', 0, '#']];
      $scope.keyCodes = [].concat.apply([], $scope.numericRows).map(function(r) { return r.toString(); });

      $scope.dial = function(code) {
        $scope.onDial({$event: code.toString()});
      };

      $scope.minimize = function() {
        $scope.minimized = !$scope.minimized;
      };
    }],

    link: function($scope, $el) {
      var onKeycode = function(ev) {
        var keyCode = ev.key;
        if($scope.keyCodes.indexOf(keyCode) > -1) {
          $scope.dial(keyCode);

          var tone = $scope.tones[keyCode];
          if(tone && typeof tone === 'function') {
            tone();
          }
        }

        if(keyCode === 'm') {
          $scope.onMute();
        }
      };

      var widgetEl = $el.find('.draggable');

      var storedX = $window.localStorage.getItem('docked-talk-widget-x');
      if(storedX !== null) {
        widgetEl.css('left', parseInt(storedX));
      }

      var startX = 0, x = storedX || widgetEl.offset().left;
      function mousemove(event) {
        x = event.screenX - startX;
        $window.localStorage.setItem('docked-talk-widget-x', x);
        widgetEl.css({ left:  x + 'px' });
      }

      function mouseup() {
        $document.off('mousemove', mousemove);
        $document.off('mouseup', mouseup);
      }

      $scope.startDrag = function(event) {
        event.preventDefault();
        startX = event.screenX - x;
        $document.on('mousemove', mousemove);
        $document.on('mouseup', mouseup);
      };

      $window.addEventListener('keyup', onKeycode, false);
      $scope.$on('$destroy', function() {
        $window.removeEventListener('keyup', onKeycode);
      });

      $scope.trust = function(file) {
        return $sce.trustAsResourceUrl(file);
      };
    }
  };
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/directives/dialpad-widget/dialpad-widget.controller.js
 ** module id = 178
 ** module chunks = 0
 **/